export default {
    legalVisitType: "Visit Type",
    date: "Date",
    doctor: "Doctor",
    consultation: "Consultation",
    result: "Result",
    description: "Description",
}